import { render, staticRenderFns } from "./hongtou.vue?vue&type=template&id=3dacddfe&scoped=true"
import script from "./hongtou.vue?vue&type=script&lang=js"
export * from "./hongtou.vue?vue&type=script&lang=js"
import style0 from "./hongtou.vue?vue&type=style&index=0&id=3dacddfe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dacddfe",
  null
  
)

export default component.exports